
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ConversationalAgentThreadResource,
  CreateConversationalAgentThreadRequest,
} from '../models';
import {
    ConversationalAgentThreadResourceFromJSON,
    ConversationalAgentThreadResourceToJSON,
    CreateConversationalAgentThreadRequestFromJSON,
    CreateConversationalAgentThreadRequestToJSON,
} from '../models';

export interface CreateThreadRequest {
    createConversationalAgentThreadRequest: CreateConversationalAgentThreadRequest;
}

/**
 * 
 */
export class ConversationalAgentApi extends runtime.BaseAPI {

    /**
     * Create a conversational agent thread for the connected client
          */
    async createThreadRaw(requestParameters: CreateThreadRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ConversationalAgentThreadResource>> {
        if (requestParameters['createConversationalAgentThreadRequest'] == null) {
            throw new runtime.RequiredError(
                'createConversationalAgentThreadRequest',
                'Required parameter "createConversationalAgentThreadRequest" was null or undefined when calling createThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ConversationalAgentThreadResource>({
            path: `/project-client/api/conversational-agent/threads`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateConversationalAgentThreadRequestToJSON(requestParameters['createConversationalAgentThreadRequest']),
        }, initOverrides);

        if (response._data) { response._data=ConversationalAgentThreadResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a conversational agent thread for the connected client
          */
    async createThread(requestParameters: CreateThreadRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ConversationalAgentThreadResource> {
        const response = await this.createThreadRaw(requestParameters, initOverrides);
        return response._data;
    }

}
